import script from "./LicenceBind.vue?vue&type=script&setup=true&lang=js"
export * from "./LicenceBind.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__